import React from 'react';

import RequiredAsterisk from '@3.0/Forms/Label/RequiredAsterisk';
import cn from 'utils/cn';

function FormElemLabel({ children, marginBottom = true, required = false, ...labelProps }) {
  return (
    <label
      {...labelProps}
      data-testid="form-elem-label"
      className={cn(
        'tw:block tw:text-sm/4 tw:font-light',
        marginBottom && 'mb1',
        labelProps?.className
      )}
    >
      {children}
      <RequiredAsterisk required={required} />
    </label>
  );
}

export default FormElemLabel;
